import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deletePresentationData, getPresentationDatas,} from "../../../redux/modules/Presentation/action";

class Presentation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getPresentationDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.presentation.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const presentationColumn = [];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"Presentation Data"}
                        data={this.props.presentation.datas}
                        columns={presentationColumn}
                        action={["update"]}
                        trash={true}
                        deleteAction={(id) => this.props.deletePresentationData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    presentation: state.presentation,
});

const mapDispatchToProps = {
    getPresentationDatas,
    deletePresentationData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(Presentation)
);
